import type { StaticDataRouteOption } from "@tanstack/react-router"

import { SettingsNavigation } from "../SettingsNavigation/SettingsNavigation"
import { TeamSettingsViewTopBar } from "./TopBar"

export const teamSettingsViewStaticData: StaticDataRouteOption = {
	leftSlideOut: SettingsNavigation,
	topBar: TeamSettingsViewTopBar,
}
